export function filterFileName(fileName) {
  const filteredFileName = fileName.replace(
    /[^a-zA-Z0-9\u4e00-\u9fff\u1100-\u11ff\u3130-\u318f\ua960-\ua97f\uac00-\ud7af\ud7b0-\ud7ff\u3040-\u309f\u30a0-\u30ff!.\-_()]+/g,
    "_",
  );
  return filteredFileName;
}
